"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserOnboardingStepStatus = void 0;
/**
 * The different statuses that an onboarding step can have.
 */
var UserOnboardingStepStatus;
(function (UserOnboardingStepStatus) {
    /**
     * The step has not been started yet.
     */
    UserOnboardingStepStatus["NOT_STARTED"] = "NOT_STARTED";
    /**
     * The step has been started but is not complete yet.
     */
    UserOnboardingStepStatus["STARTED"] = "STARTED";
    /**
     * The step has all the required informations to be complete.
     */
    UserOnboardingStepStatus["COMPLETE"] = "COMPLETE";
})(UserOnboardingStepStatus = exports.UserOnboardingStepStatus || (exports.UserOnboardingStepStatus = {}));
//# sourceMappingURL=UserOnboardingStepStatus.js.map